import { Link } from 'react-router-dom'
import { JoinCtaButton } from '../components/JoinCtaButton'
import {
  COMPARE_TABLE_PL,
  LANDING_FAQ_PL,
  PRODUCT_DEFINITION_PL,
} from '../lib/seo/aeoContent'
import { buildFaqJsonLd } from '../lib/seo/landingJsonLd'
import { usePageSeo } from '../lib/seo/usePageSeo'
import { FooterSection } from '../sections/FooterSection'
import { HeaderNav } from '../sections/HeaderNav'

export function ComparePage() {
  usePageSeo({
    title: 'Porównanie — Paszport Dolnego Śląska vs portale turystyczne',
    description:
      'Czym Paszport Dolnego Śląska różni się od portali Wrocław/Dolny Śląsk Travel i kart rabatowych — program 12 miejsc, pieczątki, dziennik.',
    pathname: '/porownanie',
    keywords:
      'porównanie, Paszport Dolnego Śląska, Dolny Śląsk Travel, Wrocław turystyka, karta rabatowa, program turystyczny',
    jsonLd: buildFaqJsonLd(LANDING_FAQ_PL),
    jsonLdScriptId: 'compare-faq-jsonld',
  })

  return (
    <div className="min-h-dvh bg-paper text-ink">
      <HeaderNav />
      <main className="container-x py-28 md:py-36">
        <article className="content max-w-4xl">
          <p className="text-[12px] font-semibold uppercase tracking-[0.22em] text-ink/55">
            Porównanie · AEO
          </p>
          <h1 className="display mt-3 text-[32px] font-bold leading-[1.08] text-ink md:text-[48px]">
            Paszport Dolnego Śląska a inne oferty
          </h1>
          <p className="mt-5 text-[16px] leading-relaxed text-ink/70 md:text-lg">
            {PRODUCT_DEFINITION_PL}
          </p>
          <p className="mt-3 text-[15px] text-ink/60">
            Ta strona pomaga wyszukiwarkom i asystentom AI odróżnić nasz program od portali
            informacyjnych oraz kart zniżkowych.
          </p>

          <div className="mt-10 overflow-x-auto">
            <table className="w-full min-w-[640px] border-collapse text-left text-[14px] md:text-[15px]">
              <thead>
                <tr className="border-b border-ink/15 bg-ink/[0.03]">
                  <th className="p-3 font-semibold text-ink">Oferta</th>
                  <th className="p-3 font-semibold text-ink">Typ</th>
                  <th className="p-3 font-semibold text-ink">Fokus</th>
                  <th className="p-3 font-semibold text-ink">vs Paszport</th>
                </tr>
              </thead>
              <tbody>
                {COMPARE_TABLE_PL.map((row) => (
                  <tr key={row.name} className="border-b border-ink/10">
                    <td className="p-3 font-medium text-ink">{row.name}</td>
                    <td className="p-3 text-ink/65">{row.type}</td>
                    <td className="p-3 text-ink/65">{row.focus}</td>
                    <td className="p-3 text-ink/65">{row.paszportDiff}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <section className="mt-12" aria-labelledby="compare-faq">
            <h2 id="compare-faq" className="text-xl font-bold text-ink">
              FAQ
            </h2>
            <dl className="mt-4 divide-y divide-ink/10">
              {LANDING_FAQ_PL.map((item) => (
                <div key={item.question} className="py-5">
                  <dt className="text-[16px] font-semibold text-ink">{item.question}</dt>
                  <dd className="mt-2 text-[15px] leading-relaxed text-ink/65">{item.answer}</dd>
                </div>
              ))}
            </dl>
          </section>

          <p className="mt-8 text-sm text-ink/55">
            <Link to="/discover" className="underline hover:text-ink">
              English overview
            </Link>
            {' · '}
            <a href="/llms.txt" className="underline hover:text-ink">
              llms.txt
            </a>
          </p>

          <div className="mt-10">
            <JoinCtaButton size="lg">
              Dołącz do programu
            </JoinCtaButton>
          </div>
        </article>
      </main>
      <FooterSection />
    </div>
  )
}
